module.exports = __webpack_public_path__ + "img/Bank Aceh Syariah.ca369d57.png";